import React from 'react';

import classes from '../../css/getCSS';


const activityExtraData = (props) => {
  let text = null;
  if (props.type === 'interests' && props.item.message) {
    text = (
      <blockquote className={classes.profileFormQuote}>
        Message: {props.item.message}
      </blockquote>
    );
  }
  if (props.type === 'requests') {
    text = (
      <blockquote className={classes.profileFormQuote}>
        Requested: {props.item.options}
      </blockquote>
    );
  }

  return (
    <React.Fragment>
      {text}
      <br />
    </React.Fragment>
  );
};

export default activityExtraData;



// WEBPACK FOOTER //
// ./src/activities/components/ActivityExtraData.js